export default __webpack_public_path__ + "static/media/hands-12.20e14f8e.png";